export default __webpack_public_path__ + "static/media/hat.d9720968.svg";